import { render, staticRenderFns } from "./ns-product-detail-drawer.vue?vue&type=template&id=ff488526&scoped=true&"
import script from "./ns-product-detail-drawer.vue?vue&type=script&lang=js&"
export * from "./ns-product-detail-drawer.vue?vue&type=script&lang=js&"
import style0 from "./ns-product-detail-drawer.vue?vue&type=style&index=0&id=ff488526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff488526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff488526')) {
      api.createRecord('ff488526', component.options)
    } else {
      api.reload('ff488526', component.options)
    }
    module.hot.accept("./ns-product-detail-drawer.vue?vue&type=template&id=ff488526&scoped=true&", function () {
      api.rerender('ff488526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-shop-elements/src/ns-product-detail-drawer/ns-product-detail-drawer.vue"
export default component.exports